import Cookies from 'js-cookie';

import { ADMIN_AUTH_COOKIE_NAME } from '@constants';

export const useIsAdminAuth = (): boolean => !!Cookies.get(ADMIN_AUTH_COOKIE_NAME);
